import React, { useState } from "react";
import "./Login.css";
import { supabase, supabaseConfigError } from "../supabaseClient";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState(supabaseConfigError || "");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (supabaseConfigError) {
      setErrorMsg(supabaseConfigError);
      return;
    }

    const email = username.trim().toLowerCase();
    const pass = password.trim();

    if (email === "" || pass === "") {
      setErrorMsg("يرجى إدخال البريد الإلكتروني وكلمة المرور");
      return;
    }

    try {
      setLoading(true);

      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password: pass,
      });

      if (error) {
        console.error("Supabase login error:", error);

        if (error.message?.includes("Invalid login credentials")) {
          setErrorMsg("البريد الإلكتروني أو كلمة المرور غير صحيحة، أو المستخدم غير موجود في Supabase Authentication.");
        } else if (error.message?.includes("Email not confirmed")) {
          setErrorMsg("البريد الإلكتروني غير مؤكد. فعّل المستخدم من Supabase أو عطّل Confirm email مؤقتًا.");
        } else if (error.message?.includes("NetworkError") || error.message?.includes("fetch")) {
          setErrorMsg("لا يمكن الاتصال بـ Supabase. تأكد من الإنترنت ومن صحة REACT_APP_SUPABASE_URL و REACT_APP_SUPABASE_ANON_KEY داخل frontend/.env.");
        } else {
          setErrorMsg("خطأ من Supabase: " + error.message);
        }

        return;
      }

      if (!data?.user) {
        setErrorMsg("تعذر تسجيل الدخول، لم يتم العثور على بيانات المستخدم.");
        return;
      }

      onLogin(data.user);
    } catch (error) {
      console.error("Login error:", error);
      setErrorMsg("حدث خطأ أثناء الاتصال بـ Supabase. افتح Console لمعرفة التفاصيل.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" dir="rtl">
      <div className="login-card">
        <h1>نِظَامُ المُؤَشِّرَات</h1>
        <h2>تسجيل الدخول</h2>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>البريد الإلكتروني</label>
            <input
              type="email"
              placeholder="admin@example.com"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>كلمة المرور</label>
            <input
              type="password"
              placeholder="كلمة المرور"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>

          {errorMsg && <p className="login-error">{errorMsg}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "جارٍ التحقق..." : "دخول"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
